// src/profile.ts
var ENTITY = "ENTITY";
var INDIVIDUAL = "INDIVIDUAL";
var JOINT = "JOINT";
var TRUST = "TRUST";
var ENTITY_TYPE = {
  [INDIVIDUAL]: "Individual",
  [ENTITY]: "Entity"
};
var TA_ACCOUNT_TYPE = {
  [INDIVIDUAL]: "Individual",
  [JOINT]: "Joint",
  [TRUST]: "Trust",
  [ENTITY]: "Entity"
};
var JOINT_SUB_TYPE = {
  "JT TEN": "Joint Tenants with Right of Survivorship",
  "TEN ENT": "Tenants by Entireties",
  "TEN COM": "Tenants in Common",
  "COMM PRO": "Community Property"
};
var JOINT_SUB_TYPE_KEYS = ["JT TEN", "TEN ENT", "TEN COM", "COMM PRO"];
var TRUST_SUB_TYPE = {
  "Trust - Revocable": "Revocable",
  "Trust - Irrevocable or Institution": "Irrevocable or Institution"
};
var TRUST_SUB_TYPE_KEYS = ["Trust - Revocable", "Trust - Irrevocable or Institution"];
var ENTITY_SUB_TYPE = [
  "Corporation",
  "LLC",
  "Partnership",
  "Association or Club",
  "Charity",
  "Religious Organization",
  "School",
  "Broker",
  "Financial Institution",
  "IRA",
  "Pension or Profit Sh Plan - Revocable",
  "Pension or Profit Sh Plan - Irrevocable or Institution"
];
var TA_ACCOUNT_TYPE_OPTIONS = Object.entries(TA_ACCOUNT_TYPE).map(([value, label]) => ({ value, label }));
var ENTITY_TYPE_OPTIONS = Object.entries(ENTITY_TYPE).map(([value, label]) => ({ value, label }));
var ENTITY_SUB_TYPE_OPTIONS = ENTITY_SUB_TYPE.map((value) => ({
  value,
  label: value
}));
var JOINT_SUB_TYPE_OPTIONS = Object.entries(JOINT_SUB_TYPE).map(([value, label]) => ({ value, label }));
var TRUST_SUB_TYPE_OPTIONS = Object.entries(TRUST_SUB_TYPE).map(([value, label]) => ({ value, label }));
var US_CITIZEN = "US_CITIZEN";
var INTERNATIONAL = "INTERNATIONAL";
var CITIZENSHIP = {
  [US_CITIZEN]: "US_CITIZEN",
  [INTERNATIONAL]: "INTERNATIONAL"
};
var CITIZENSHIP_OPTIONS = Object.entries(CITIZENSHIP).map(([value, label]) => ({ value, label }));
export {
  CITIZENSHIP,
  CITIZENSHIP_OPTIONS,
  ENTITY,
  ENTITY_SUB_TYPE,
  ENTITY_SUB_TYPE_OPTIONS,
  ENTITY_TYPE,
  ENTITY_TYPE_OPTIONS,
  INDIVIDUAL,
  INTERNATIONAL,
  JOINT,
  JOINT_SUB_TYPE,
  JOINT_SUB_TYPE_KEYS,
  JOINT_SUB_TYPE_OPTIONS,
  TA_ACCOUNT_TYPE,
  TA_ACCOUNT_TYPE_OPTIONS,
  TRUST,
  TRUST_SUB_TYPE,
  TRUST_SUB_TYPE_KEYS,
  TRUST_SUB_TYPE_OPTIONS,
  US_CITIZEN
};
//# sourceMappingURL=profile.mjs.map